// extracted by mini-css-extract-plugin
module.exports = {"searchHead":"StavSkladu_searchHead__1PNlo"};